import { AssetId } from "@carnegie-learning/common-types";
import { Asset } from "@carnegie-learning/cure-types";
import { FeathersServicePagination, FeathersServicePaginationParameters } from "@carnegie-learning/data-access-core";
import { createAction, props } from "@ngrx/store";

// ============== Load all Assets ============
export const LOAD_ASSETS = "[Assets] Load Assets";
export const LOAD_ASSETS_SUCCESS = "[Assets] Load Assets Success";
export const LOAD_ASSETS_FAIL = "[Assets] Load Assets Fail";

export const LoadAssets = createAction(
    LOAD_ASSETS,
    props<{
        paginationParams: FeathersServicePaginationParameters<Asset>;
    }>()
);

export const LoadAssetsSuccess = createAction(
    LOAD_ASSETS_SUCCESS,
    props<{
        payload: FeathersServicePagination<Asset>;
    }>()
);

export const LoadAssetsFail = createAction(
    LOAD_ASSETS_FAIL,
    props<{
        payload: any;
    }>()
);

// ============== Load selected Asset ============
export const LOAD_ASSET = "[Assets] Load Asset";
export const LOAD_ASSET_SUCCESS = "[Assets] Load Asset Success";
export const LOAD_ASSET_FAIL = "[Assets] Load Asset Fail";

export const LoadAsset = createAction(
    LOAD_ASSET,
    props<{
        assetId: AssetId;
    }>()
);

export const LoadAssetSuccess = createAction(
    LOAD_ASSET_SUCCESS,
    props<{
        payload: Asset;
    }>()
);

export const LoadAssetFail = createAction(
    LOAD_ASSET_FAIL,
    props<{
        payload: any;
    }>()
);

// ------ Set Pagination Params -------
export const SET_ASSETS_PAGINATION_PARAMS =
    "[Content-Builder] Set Pagination Params";

export const SetAssetsPaginationParams = createAction(
    SET_ASSETS_PAGINATION_PARAMS,
    props<{
        payload: any;
    }>()
);

// ============== Set selected Assets ============
export const SET_SELECTED_ASSETS = "[Assets] Set selected Assets";

export const SetSelectedAssets = createAction(
    SET_SELECTED_ASSETS,
    props<{
        payload: Asset[];
    }>()
);

// ============== Set selected Asset ============
export const SET_SELECTED_ASSET = "[Assets] Set selected Asset";

export const SetSelectedAsset = createAction(
    SET_SELECTED_ASSET,
    props<{
        payload: Asset;
    }>()
);
